import React from 'react';
import { useSelector } from 'react-redux';
import { HeaderPanel, Link } from 'carbon-components-react';
import { selectHeaderPanelExpand } from 'redux/app/selectors';
export interface PageProps {
  panelHeading?: number | string;
  panelFooter?: object;
  isExpanded: boolean;
  closeButtonHandler?: Function;
  hideCloseButton?: boolean;
  isModel?: boolean;
  className?: string;
  panelHeadingLabel?: number | string;
}

/**
 * CUSTOM RIGHT HAND SIDE HEADER PANEL
 */
export const CustomRightHeaderPanel: React.FC<PageProps> = (props: any) => {
  const headerPanelExpand: any | undefined = useSelector(
    selectHeaderPanelExpand
  );
  const {
    isExpanded,
    closeButtonHandler,
    panelHeading,
    panelFooter,
    hideCloseButton = false,
    isModel = true,
    className = '',
    panelHeadingLabel
  } = props;
  return (
    props.children && (
      <div
        className={`custom-panel--wrapper ${isModel ? 'bx--modal' : ''} ${
          isExpanded ? 'is-visible' : ''
        } ${className}`}
        data-testid="cust-right-panel"
        role="presentation"
        style={
          isExpanded && headerPanelExpand?.isOpen
            ? { display: 'none' }
            : undefined
        }
      >
        <HeaderPanel
          aria-label="Header Panel"
          className="custom-panel  custom-scroller"
          expanded
        >
          <section className="custom-panel--top">
            <div className="heading--left">
              {panelHeadingLabel && (
                <label className="heading--left-label">
                  {panelHeadingLabel}
                </label>
              )}
              <p className="heading--left-text">{panelHeading}</p>
            </div>
            {!hideCloseButton && (
              <Link href="#" onClick={() => closeButtonHandler()}>
                Close
              </Link>
            )}
          </section>
          <section className="custom-panel--body">{props.children}</section>
          {panelFooter && (
            <section className="custom-panel--footer">{panelFooter}</section>
          )}
        </HeaderPanel>
      </div>
    )
  );
};
